import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProductoImagenService {
  readonly defaultMaxSizeMb = 2;
  private readonly allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];

  validarImagen(file: File | null, maxSizeMb: number): string | null {
    if (!file) {
      return null;
    }

    if (!this.allowedTypes.includes(file.type)) {
      return 'Formato no permitido. Usa JPG, PNG o WEBP.';
    }

    const maxSizeBytes = maxSizeMb * 1024 * 1024;
    if (file.size > maxSizeBytes) {
      return `La imagen excede ${maxSizeMb}MB.`;
    }

    return null;
  }

  buildFormData<T extends object>(
    payload: T,
    options?: {
      file?: File;
      fileFieldName?: string;
      nullAsEmptyKeys?: string[];
    },
  ): FormData {
    const formData = new FormData();
    const nullAsEmptyKeys = new Set(options?.nullAsEmptyKeys ?? []);

    for (const [key, value] of Object.entries(payload as Record<string, unknown>)) {
      if (value === undefined) {
        continue;
      }

      if (value === null) {
        if (nullAsEmptyKeys.has(key)) {
          formData.append(key, '');
        }
        continue;
      }

      formData.append(key, String(value));
    }

    if (options?.file) {
      formData.append(options.fileFieldName ?? 'imagen', options.file);
    }

    return formData;
  }
}
